import React, { useState } from "react";
import Brokoli from "../../assets/images/brokoli.png";
import IconTrash from "../../assets/icons/trash-white.svg";
import { Link } from "react-router-dom";

import JagungManis from "../../assets/images/sayur/buah/jagung.jpeg";
import Kentank from "../../assets/images/sayur/umbi/kentang.jpeg";
import Bayam from "../../assets/images/sayur/daun/bayam.jpeg";
import Wortel from "../../assets/images/sayur/akar/wortel.jpeg";

const Troli = (props) => {
  const [count, setCount] = useState(0);
  const [countSec, setCountSec] = useState(0);
  const [countThird, setCountThird] = useState(0);
  const [countFourth, setCountFourth] = useState(0);
  const [showInputNote, setShowInputNote] = useState(false);
  const [toggleDeleteBtnIndex, setToggleDeleteBtnIndex] = useState(null);

  const toggleDelete = (deleteIndex) => {
    if (toggleDeleteBtnIndex === deleteIndex) setToggleDeleteBtnIndex(null);
    else setToggleDeleteBtnIndex(deleteIndex);
  };

  return (
    <div className="fixed h-full w-full top-0 right-0 z-20 overflow-hidden">
      <div className="bg-gray-300 opacity-50 h-full w-full absolute"></div>
      <div className="relative bg-white h-full w-full max-w-md ml-auto opacity-100 z-50  pt-4">
        <div className="flex flex-col h-full ">
          <div className="flex justify-between items-center px-8 border-b border-gray-300 pb-4">
            <h5 className="text-lg text-font-gray">Troli Belanja</h5>
            <button onClick={props.handdleClick} className="h-4 w-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 18.461 19.883"
              >
                <g
                  id="Group_3838"
                  data-name="Group 3838"
                  transform="translate(1.413 1.413)"
                >
                  <line
                    id="Line_434"
                    data-name="Line 434"
                    x1="15.635"
                    y2="17.057"
                    fill="none"
                    stroke="#596375"
                    strokeLinecap="round"
                    strokeWidth="2"
                  />
                  <line
                    id="Line_435"
                    data-name="Line 435"
                    x2="15.635"
                    y2="17.057"
                    fill="none"
                    stroke="#596375"
                    strokeLinecap="round"
                    strokeWidth="2"
                  />
                </g>
              </svg>
            </button>
          </div>
          <div className="flex flex-col px-8 py-3 flex-1 h-screen overflow-scroll mb-4">
            {/* Troli Item 2 */}
            <div className="flex flex-col items-stretch my-2">
              <div className="flex">
                <div className="my-auto">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox text-yellow-400 h-6 w-6 rounded-full"
                    />
                    <span className="ml-2 hidden">Brokoli 1</span>
                  </label>
                </div>
                <img src={Brokoli} alt="Brokoli" className="h-24 mx-2" />
                <div className="flex flex-grow">
                  <div className="flex flex-col justify-between ">
                    <div className="flex flex-col ">
                      <p className="text-font-gray ">Brokoli</p>
                      <p className="text-font-gray-light text-xs">250gram</p>
                    </div>
                    <div className="flex flex-col ">
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.000</p>
                    </div>
                  </div>

                  <div className="flex flex-col justify-between items-end">
                    <button
                      className="px-2 py-1"
                      onClick={() => {
                        toggleDelete(1);
                      }}
                    >
                      {" "}
                      <img src={IconTrash} className="h-5 w-5" alt="" />
                    </button>
                    <div className="flex border border-gray-100 rounded-l-lg rounded-r-lg w-24">
                      <button
                        onClick={() => setCount(count - 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        -{" "}
                      </button>
                      <input
                        type="number"
                        className="flex flex-shrink relative flex-grow w-4 outline-none"
                        value={count}
                        min={0}
                      />
                      <button
                        onClick={() => setCount(count + 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        +{" "}
                      </button>
                    </div>
                    {toggleDeleteBtnIndex === 1 && (
                      <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                        <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                          <div
                            className="py-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-labelledby="options-menu"
                          >
                            <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                              <p className="text-sm font-semibold">
                                Yakin Ingin menghapus Brokoli ?
                              </p>
                              <div className="flex ml-auto mt-6">
                                <button
                                  className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(1);
                                  }}
                                >
                                  Tidak
                                </button>
                                <button
                                  className="text-sm text-white bg-green-600 border border-bg-green-700 px-3 py-1 rounded"
                                  onClick={() => {
                                    toggleDelete(1);
                                  }}
                                >
                                  Ya
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {showInputNote ? (
                <label class="block">
                  <input
                    className="form-input ml-8 mt-2  block w-32 text-xs py-2"
                    placeholder="Catatan Pembelian"
                    onBlur={() => setShowInputNote(!showInputNote)}
                  />
                </label>
              ) : (
                <p
                  className="text-xs text-orange-400 ml-8 mt-2 cursor-pointer"
                  onClick={() => setShowInputNote(!showInputNote)}
                >
                  Tulis Catatan Product
                </p>
              )}
            </div>
            {/* End Troli Item */}
            {/* Troli Item 2 */}
            <div className="flex items-stretch my-2 flex-col">
              <div className="flex">
                <div className="my-auto">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox text-yellow-400 h-6 w-6 rounded-full"
                    />
                    <span className="ml-2 hidden">Brokoli 1</span>
                  </label>
                </div>
                <img src={JagungManis} alt="Brokoli" className="h-24 mx-2" />
                <div className="flex flex-grow">
                  <div className="flex flex-col justify-between ">
                    <div className="flex flex-col ">
                      <p className="text-font-gray ">Jagung</p>
                      <p className="text-font-gray-light text-xs">250gram</p>
                    </div>
                    <div className="flex flex-col ">
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 4.500</p>
                    </div>
                  </div>

                  <div className="flex flex-col justify-between items-end">
                    <button
                      className="px-2 py-1"
                      onClick={() => {
                        toggleDelete(2);
                      }}
                    >
                      {" "}
                      <img src={IconTrash} className="h-5 w-5" alt="" />
                    </button>
                    <div className="flex border border-gray-100 rounded-l-lg rounded-r-lg w-24">
                      <button
                        onClick={() => setCountSec(countSec - 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        -{" "}
                      </button>
                      <input
                        type="number"
                        className="flex flex-shrink relative flex-grow w-4 outline-none"
                        value={countSec}
                      />
                      <button
                        onClick={() => setCountSec(countSec + 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        +{" "}
                      </button>
                      {toggleDeleteBtnIndex === 2 && (
                        <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                          <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                            <div
                              className="py-1"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="options-menu"
                            >
                              <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                <p className="text-sm font-semibold">
                                  Yakin Ingin menghapus jagung ?
                                </p>
                                <div className="flex ml-auto mt-6">
                                  <button
                                    className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(2);
                                    }}
                                  >
                                    Tidak
                                  </button>
                                  <button
                                    className="text-sm text-white bg-green-600 border border-bg-green-700 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(2);
                                    }}
                                  >
                                    Ya
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {showInputNote ? (
                <label class="block">
                  <input
                    className="form-input ml-8 mt-2  block w-32 text-xs py-2"
                    placeholder="Catatan Pembelian"
                    onBlur={() => setShowInputNote(!showInputNote)}
                  />
                </label>
              ) : (
                <p
                  className="text-xs text-orange-400 ml-8 mt-2 cursor-pointer"
                  onClick={() => setShowInputNote(!showInputNote)}
                >
                  Tulis Catatan Product
                </p>
              )}
            </div>
            {/* End Troli Item */}
            {/* Troli Item 2 */}
            <div className="flex items-stretch my-2 flex-col">
              <div className="flex">
                <div className="my-auto">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox text-yellow-400 h-6 w-6 rounded-full"
                      defaultValue="2"
                    />
                    <span className="ml-2 hidden">Brokoli 1</span>
                  </label>
                </div>
                <img src={Kentank} alt="Brokoli" className="h-24 mx-2" />
                <div className="flex flex-grow">
                  <div className="flex flex-col justify-between ">
                    <div className="flex flex-col ">
                      <p className="text-font-gray ">Kentang</p>
                      <p className="text-font-gray-light text-xs">250gram</p>
                    </div>
                    <div className="flex flex-col ">
                      <p className="text-gray-400 text-sm line-through">
                        Rp.5.500
                      </p>
                      <p className="text-basic-orange ">Rp 5.000</p>
                    </div>
                  </div>

                  <div className="flex flex-col justify-between items-end">
                    <button
                      className="px-2 py-1"
                      onClick={() => {
                        toggleDelete(3);
                      }}
                    >
                      {" "}
                      <img src={IconTrash} className="h-5 w-5" alt="" />
                    </button>
                    <div className="flex border border-gray-100 rounded-l-lg rounded-r-lg w-24">
                      <button
                        onClick={() => setCountThird(countThird - 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        -{" "}
                      </button>
                      <input
                        type="number"
                        className="flex flex-shrink relative flex-grow w-4 outline-none"
                        value={countThird}
                      />
                      <button
                        onClick={() => setCountThird(countThird + 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        +{" "}
                      </button>
                      {toggleDeleteBtnIndex === 3 && (
                        <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                          <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                            <div
                              className="py-1"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="options-menu"
                            >
                              <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                <p className="text-sm font-semibold">
                                  Yakin Ingin menghapus kentang ?
                                </p>
                                <div className="flex ml-auto mt-6">
                                  <button
                                    className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(3);
                                    }}
                                  >
                                    Tidak
                                  </button>
                                  <button
                                    className="text-sm text-white bg-green-600 border border-bg-green-700 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(3);
                                    }}
                                  >
                                    Ya
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {showInputNote ? (
                <label class="block">
                  <input
                    className="form-input ml-8 mt-2  block w-32 text-xs py-2"
                    placeholder="Catatan Pembelian"
                    onBlur={() => setShowInputNote(!showInputNote)}
                  />
                </label>
              ) : (
                <p
                  className="text-xs text-orange-400 ml-8 mt-2 cursor-pointer"
                  onClick={() => setShowInputNote(!showInputNote)}
                >
                  Tulis Catatan Product
                </p>
              )}
            </div>
            {/* End Troli Item */}
            {/* Troli Item 2 */}
            <div className="flex items-stretch my-2 flex-col">
              <div className="flex">
                <div className="my-auto">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox text-yellow-400 h-6 w-6 rounded-full"
                      defaultValue="1"
                    />
                    <span className="ml-2 hidden">Brokoli 1</span>
                  </label>
                </div>
                <img src={Bayam} alt="Brokoli" className="h-24 mx-2" />
                <div className="flex flex-grow">
                  <div className="flex flex-col justify-between ">
                    <div className="flex flex-col ">
                      <p className="text-font-gray ">Bayam</p>
                      <p className="text-font-gray-light text-xs">1 ikat</p>
                    </div>
                    <div className="flex flex-col ">
                      <p className="text-basic-orange ">Rp 2.000</p>
                    </div>
                  </div>

                  <div className="flex flex-col justify-between items-end">
                    <button
                      className="px-2 py-1"
                      onClick={() => {
                        toggleDelete(4);
                      }}
                    >
                      {" "}
                      <img src={IconTrash} className="h-5 w-5" alt="" />
                    </button>
                    <div className="flex border border-gray-100 rounded-l-lg rounded-r-lg w-24">
                      <button
                        onClick={() => setCountFourth(countFourth - 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        -{" "}
                      </button>
                      <input
                        type="number"
                        className="flex flex-shrink relative flex-grow w-4 outline-none"
                        value={countFourth}
                      />
                      <button
                        onClick={() => setCountFourth(countFourth + 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        +{" "}
                      </button>
                      {toggleDeleteBtnIndex === 4 && (
                        <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                          <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                            <div
                              className="py-1"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="options-menu"
                            >
                              <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                <p className="text-sm font-semibold">
                                  Yakin Ingin menghapus bayam ?
                                </p>
                                <div className="flex ml-auto mt-6">
                                  <button
                                    className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(4);
                                    }}
                                  >
                                    Tidak
                                  </button>
                                  <button
                                    className="text-sm text-white bg-green-600 border border-bg-green-700 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(4);
                                    }}
                                  >
                                    Ya
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {showInputNote ? (
                <label class="block">
                  <input
                    className="form-input ml-8 mt-2  block w-32 text-xs py-2"
                    placeholder="Catatan Pembelian"
                    onBlur={() => setShowInputNote(!showInputNote)}
                  />
                </label>
              ) : (
                <p
                  className="text-xs text-orange-400 ml-8 mt-2 cursor-pointer"
                  onClick={() => setShowInputNote(!showInputNote)}
                >
                  Tulis Catatan Product
                </p>
              )}
            </div>
            {/* End Troli Item */}

            {/* Troli Item 2 */}
            <div className="flex items-stretch my-2 flex-col mb-24">
              <div className="flex">
                <div className="my-auto">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      className="form-checkbox text-yellow-400 h-6 w-6 rounded-full"
                      defaultValue="1"
                    />
                    <span className="ml-2 hidden">Brokoli 1</span>
                  </label>
                </div>
                <img src={Wortel} alt="Brokoli" className="h-24 mx-2" />
                <div className="flex flex-grow">
                  <div className="flex flex-col justify-between ">
                    <div className="flex flex-col ">
                      <p className="text-font-gray ">Wortel</p>
                      <p className="text-font-gray-light text-xs">250g</p>
                    </div>
                    <div className="flex flex-col ">
                      <p className="text-orange-500 ">Rp 2.000</p>
                    </div>
                  </div>

                  <div className="flex flex-col justify-between items-end">
                    <button
                      className="px-2 py-1"
                      onClick={() => {
                        toggleDelete(5);
                      }}
                    >
                      {" "}
                      <img src={IconTrash} className="h-5 w-5" alt="" />
                    </button>
                    <div className="flex border border-gray-100 rounded-l-lg rounded-r-lg w-24">
                      <button
                        onClick={() => setCountFourth(countFourth - 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        -{" "}
                      </button>
                      <input
                        type="number"
                        className="flex flex-shrink relative flex-grow w-4 outline-none"
                        value={countFourth}
                      />
                      <button
                        onClick={() => setCountFourth(countFourth + 1)}
                        className="px-3 py-1 text-center"
                      >
                        {" "}
                        +{" "}
                      </button>
                      {toggleDeleteBtnIndex === 5 && (
                        <div className="origin-top-right absolute right-0 -mt-10 mr-8  w-64 rounded-md shadow-lg">
                          <div className="rounded-md bg-white shadow-xs  py-2 shadow-sm">
                            <div
                              className="py-1"
                              role="menu"
                              aria-orientation="vertical"
                              aria-labelledby="options-menu"
                            >
                              <div className="flex flex-col px-4 py-2 flex-wrap justify-between">
                                <p className="text-sm font-semibold">
                                  Yakin Ingin menghapus wortel ?
                                </p>
                                <div className="flex ml-auto mt-6">
                                  <button
                                    className="text-sm bg-white border border-gray-500 mx-2 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(5);
                                    }}
                                  >
                                    Tidak
                                  </button>
                                  <button
                                    className="text-sm text-white bg-green-600 border border-bg-green-700 px-3 py-1 rounded"
                                    onClick={() => {
                                      toggleDelete(5);
                                    }}
                                  >
                                    Ya
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {showInputNote ? (
                <label class="block">
                  <input
                    className="form-input ml-8 mt-2  block w-32 text-xs py-2"
                    placeholder="Catatan Pembelian"
                    onBlur={() => setShowInputNote(!showInputNote)}
                  />
                </label>
              ) : (
                <p
                  className="text-xs text-orange-400 ml-8 mt-2 cursor-pointer"
                  onClick={() => setShowInputNote(!showInputNote)}
                >
                  Tulis Catatan Product
                </p>
              )}
            </div>
            {/* End Troli Item */}

            {/* Troli Item 2 */}
            {/* <div className="flex items-stretch my-2 flex-col">
              <div className="my-auto">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    className="form-checkbox text-yellow-400 h-6 w-6 rounded-full"
                    defaultValue="1"
                  />
                  <span className="ml-2 hidden">Brokoli 1</span>
                </label>
              </div>
              <img src={SawiHijau} alt="Brokoli" className="h-24 mx-2" />
              <div className="flex flex-grow">
                <div className="flex flex-col justify-between ">
                  <div className="flex flex-col ">
                    <p className="text-font-gray ">Sawi</p>
                    <p className="text-font-gray-light text-xs">1 ikat</p>
                  </div>
                  <div className="flex flex-col ">
                    
                    <p className="text-orange-500 ">Rp 2.000</p>
                  </div>
                </div>

                <div className="flex flex-col justify-between items-end">
                  <button className="px-2 py-1">
                    {" "}
                    <img src={IconTrash} className="h-5 w-5" alt="" />
                  </button>
                  <div className="flex border border-gray-100 rounded-l-lg rounded-r-lg w-24">
                    <button
                      onClick={() => setCountFourth(countFourth - 1)}
                      className="px-3 py-1 text-center"
                    >
                      {" "}
                      -{" "}
                    </button>
                    <input
                      type="number"
                      className="flex flex-shrink relative flex-grow w-4 outline-none"
                      value={countFourth}
                    />
                    <button
                      onClick={() => setCountFourth(countFourth + 1)}
                      className="px-3 py-1 text-center"
                    >
                      {" "}
                      +{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div> */}
            {/* End Troli Item */}
          </div>
          {/* Footer Troli */}
          <div className="flex w-full justify-between items-center py-4 px-8 shadow-t-xl">
            <div className="my-auto">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox text-yellow-400 h-6 w-6 rounded-full"
                  defaultValue="1"
                />
                <span className="ml-2 text-gray-500 font-semibold">Semua</span>
              </label>
            </div>
            <p className="text-font-gray">Rp.126.500</p>
            <Link
              to="/checkout"
              className="bg-basic-orange text-white rounded-l-full rounded-r-full px-8 py-3 capitalize"
            >
              Beli
            </Link>
          </div>
          {/* End Footer Troli */}
        </div>
      </div>
    </div>
  );
};

export default Troli;
